import React from 'react';

export default React.createContext({
  uuid: '',
  setUuid: () => {}
});
